export const titleStyles = {
  textSize: 'md',
  style: 'outlined',
  gameId: 'brawlstars',
} as const
